import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import ContentGridItem from "arena/components/ContentGridItem";
import Previewable from "arena/components/Previewable";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import LoadMore from "core/components/LoadMore";

export default function ContentGrid({
  xs,
  sm,
  md,
  lg,
  xl,
  nodes,
  type,
  collectionId,
  productId,
  previewMode,
  hasMore,
  onLoadMore,
  loading,
  nextPage,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{ pl: { xs: 2, sm: 0 }, pr: { xs: 2, sm: 0 } }}
      test-id="ContentGrid"
    >
      <Grid container spacing={2}>
        {nodes.map((content) => (
          <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl} key={content.id}>
            <Previewable isMobile={isMobile}>
              {(focused) => (
                <ContentGridItem
                  content={content}
                  play={focused}
                  type={type}
                  collectionId={collectionId}
                  productId={productId}
                  previewMode={previewMode}
                  smallTitle={12 / md > 3}
                />
              )}
            </Previewable>
          </Grid>
        ))}
      </Grid>

      {/* Показываем LoadMore компонент внизу грида */}
      {hasMore && !loading && (
        <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
          <LoadMore key={nextPage} onLoadMore={onLoadMore} />
        </Box>
      )}
    </Box>
  );
}

ContentGrid.propTypes = {
  xs: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  sm: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  md: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  lg: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  xl: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  nodes: PropTypes.array,
  type: PropTypes.string,
  collectionId: PropTypes.string,
  productId: PropTypes.string,
  previewMode: PropTypes.oneOf(["HORIZONTAL", "VERTICAL"]),
  hasMore: PropTypes.bool,
  onLoadMore: PropTypes.func,
  loading: PropTypes.bool,
  nextPage: PropTypes.number,
};

ContentGrid.defaultProps = {
  xs: 6,
  sm: 6,
  md: 4,
  lg: 4,
  xl: 4,
  nodes: [],
  hasMore: false,
  onLoadMore: null,
  loading: false,
  nextPage: 0,
};
